import React, { useState, useEffect } from "react";
import {
  useUserEmail,
  useOrgPk,
} from "../../../Layout/AppMain/LoginStatusContext";
// import {
//   useUserEmail,
//   useOrgPk,
// } from "../../../../Layout/AppMain/LoginStatusContext";
import {
  Card,
  Table,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import TextareaAutosize from "react-textarea-autosize";
import { DELETE_ROLE, GET_ORG_PROFILE, REGISTER_MAIL } from "../../../queries";
// import {
//   DELETE_ROLE,
//   GET_ORG_PROFILE,
//   REGISTER_MAIL,
// } from "../../../../queries";
import { useMutation, useLazyQuery } from "@apollo/client";
// import HorizontalScroller from "react-horizontal-scroll-container";

const SettingOrgTab5 = ({ obj, refetch, userRole }) => {
  const userEmail = useUserEmail();
  const orgId = useOrgPk();
  //モーダル
  const [modal1, setModal1] = useState(false);
  const modalToggle1 = () => setModal1(!modal1);
  const [modal2, setModal2] = useState(false);
  const modalToggle2 = () => setModal2(!modal2);

  //ドロップダウン
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownToggle = () => setDropdownOpen((prevState) => !prevState);
  const [dropdownValue, setDropdownValue] = useState("権限");

  // ミューテーション
  const [sendMail] = useMutation(REGISTER_MAIL);
  const [email, setEmail] = useState("");
  const [ability, setAbility] = useState("権限");
  const [deleteRole, { deletedRole }] = useMutation(DELETE_ROLE, {
    refetchQueries: [{ query: GET_ORG_PROFILE }],
  });

  //roleId State
  const [userId, setUserId] = useState("");

  const addMember = async (e) => {
    try {
      if (ability === "権限") {
        alert("権限を選択してください");
      } else {
        modalToggle1();
        const result = await sendMail({
          variables: { email: email, orgId: obj.id, ability: ability },
        });
        alert(result.data.mail.result);
      }
    } catch (err) {
      alert(err.message);
    }
  };

  const deleteRoleFunc = async (e) => {
    try {
      await deleteRole({
        variables: {
          roleId: userId,
        },
      });
      refetch();
    } catch (err) {
      alert(err.message);
    }
  };

  const canEditMembers = obj.canEditMembers;

  return (
    <div>
      <Card className="mb-2  org_contentarea">
        <div className="org_subtitle_sec">
          <div
            className="org_subtitle"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h4 style={{ fontSize: 16, marginBottom: 0, fontWeight: "bold" }}>
              メンバー
            </h4>
          </div>
          {userRole === "can_edit" && (
            <Button className="mr-1 main_button" onClick={modalToggle1}>
              追加
            </Button>
          )}
        </div>
        {/* <HorizontalScroller className="scroller">
          <Table borderless className="mb-0">
            <thead>
              <tr>
                <th></th>
                <th>名前</th>
                <th>メールアドレス</th>
                <th>ステータス</th>
                {userRole === "can_edit" && <th>アクション</th>}
              </tr>
            </thead>
            {obj.role.edges.map((array, index) => (
              <tbody>
                <tr>
                  <th scope="row" style={{ verticalAlign: "middle" }}>
                    {index + 1}
                  </th>

                  <div
                    style={{ display: "table-cell", verticalAlign: "middle" }}
                  >
                    {array.node.user.additionalInfo === null ? (
                      <td>ユーザー名が設定されていません</td>
                    ) : (
                      <td>{array.node.user.additionalInfo.username}</td>
                    )}
                  </div>

                  <td>{array.node.user.email}</td>
                  <td>{array.node.ability}</td>
                  <td>
                    {userRole === "can_edit" && (
                      <div>
                        {canEditMembers < 2 ? (
                          <div>
                            {array.node.user.email === userEmail ? (
                              <Button
                                disabled
                                onClick={(e) => {
                                  modalToggle2();
                                  setUserId(e.target.value);
                                }}
                                className="mr-1 main_button"
                                style={{
                                  background: "#E36B6B",
                                  minWidth: "95px",
                                }}
                                value={array.node.id}
                              >
                                削除
                              </Button>
                            ) : (
                              <Button
                                onClick={(e) => {
                                  modalToggle2();
                                  setUserId(e.target.value);
                                }}
                                className="mr-1 main_button"
                                style={{
                                  background: "#E36B6B",
                                  minWidth: "95px",
                                }}
                                value={array.node.id}
                              >
                                削除
                              </Button>
                            )}
                          </div>
                        ) : (
                          <Button
                            onClick={(e) => {
                              modalToggle2();
                              setUserId(e.target.value);
                            }}
                            className="mr-1 main_button"
                            style={{ background: "#E36B6B" }}
                            value={array.node.id}
                          >
                            削除
                          </Button>
                        )}
                      </div>
                    )}
                  </td>
                </tr>
              </tbody>
            ))}
          </Table>
        </HorizontalScroller> */}
      </Card>

      <Modal isOpen={modal1} toggle={modalToggle1}>
        <ModalBody className="mt-4 ml-3 mr-3">
          <p className="bold">メールアドレス</p>
          <div style={{ display: "flex", alignItems: "center" }}>
            <TextareaAutosize
              className="form-control mr-2"
              maxRows={3}
              placeholder="xxxxx@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Dropdown isOpen={dropdownOpen} toggle={dropdownToggle}>
              <DropdownToggle
                caret
                style={{
                  background: "#fff",
                  color: "#495057",
                  borderColor: "#ced4da",
                }}
              >
                {dropdownValue}
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem
                  onClick={() => {
                    setAbility("can_edit");
                    setDropdownValue("編集");
                  }}
                >
                  編集
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    setAbility("only_view");
                    setDropdownValue("閲覧");
                  }}
                >
                  閲覧
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        </ModalBody>
        <ModalFooter style={{ background: "#fff", borderTop: "none" }}>
          <Button onClick={addMember} className="main_button">
            送信
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={modal2} toggle={modalToggle2}>
        <ModalBody className="mt-4 ml-3 mr-3 mb-2">
          <p className="bold">メンバーを削除します。よろしいですか？</p>
          <Button
            onClick={() => {
              deleteRoleFunc();
              modalToggle2();
            }}
            className="main_button"
            style={{ background: "#E36B6B" }}
          >
            削除
          </Button>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default SettingOrgTab5;
